import { createFileRoute } from "@tanstack/react-router";
import AdminContentNewPage from "@/pages/admin/content/new";
import { useContentPermissions } from "@/pages/admin/content";

export const Route = createFileRoute("/app/admin/content/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllContent, userCanViewAllContent } = useContentPermissions();

  return (
    <AdminContentNewPage
      userCanEditAllContent={userCanEditAllContent}
      userCanViewAllContent={userCanViewAllContent}
    />
  );
}
